export class InstitutionUnit {
  public id: string;
  public institution_id: any;
  public name: string;
  public url: string;
}
